/* Auto-generated from inline schema 2025-08-29T08:39:05.700Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: ['national'],
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
